<template>
    <div id="videocontainer" @keydown.esc="$emit('goto', 'videomenu')" @click="$emit('goto', 'videomenu')" tabindex="0" ref="focused">
      <div v-show="showPlayButton" @click.stop="play" id="playme">PLAY</div>
      <div v-show="$route.params.id == index" v-for="(video, index) in data.videos" :key="index" class="section" :id="'section' + (index+1)">
         <div class="intro">
         <video :ref="'video'" preload="meta">
            <source :src="video.file" type="video/mp4">
            </video>
           <img v-show="false" :src="video.image" style="width:100%">
         </div>
      </div>
    </div>
</template>

<script>
const delay = t => new Promise(resolve => setTimeout(resolve, t));
export default {
  name: 'VideoComponent',
  props: {
    data: Object
  },
  data () {
    return {
        showPlayButton: false,
    }
	},
  async mounted() {
    console.log("Video component mounted")
    !this.$refs.video && await delay(350)
    try {
      if(this.$refs.video && this.$route.params.id) {
        let video = this.$refs.video[this.$route.params.id]
         video.onended = () => {console.log("video ended"); this.$router.push({name: "videomenu"})}
        await video.play()
      }
    }
    catch (err) {
      console.log("Could not play video", err.message)
      this.showPlayButton = true
    }
  },
  methods: {
    async play() {
      await this.$refs.video[this.$route.params.id].play()
      this.showPlayButton = false
      console.log("PLAY!")
    }
  },
	watch: {
    $route(to, from) {
      //console.log({to, from})
			if (to.name === "video") {
        this.$refs.focused.focus();
        let video = this.$refs.video[to.params.id];
				video.onended = () => {console.log("video ended"); this.$router.go(-1)}
        try {
          video.play()  
        }
        catch {
          console.log("Could not play video")
        }
				//console.log("Playing video: ", video)
			}
			else if (from.name === "video") {
        let video = this.$refs.video[from.params.id];
				video.pause()
				video.load()
				//video.currenTime = 0
				//console.log("Pausing video: ", video)
			}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
